import { useI18n } from "i18n";
import { Button } from "@remo-co/ui-core/src/components/Button";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { IEvent } from "modules/event/types";
import ShareEvent from "../ShareEvent";
import { useStyles } from "./RegistrationSuccess.styles";

interface IRegistrationSuccessProps {
  event: IEvent;
  onAddToCalendar: () => void;
}

const RegistrationSuccess = ({
  event,
  onAddToCalendar,
}: IRegistrationSuccessProps) => {
  const styles = useStyles();
  const { t } = useI18n(["eventLanding"]);

  return (
    <div data-testid="register-to-event-success-dialog">
      <Typography variant="h2" className={styles.registerSuccessTitle}>
        {t("eventLanding:registration.success.message")}
      </Typography>
      <Typography variant="h5" className={styles.registerStatus}>
        {t("eventLanding:successfully.registered")}
        <div>
          <strong>{event.name}</strong>
        </div>
      </Typography>
      <Button
        id="add-to-calendar-modal_primary-cta-add-to-my-calendar"
        onClick={onAddToCalendar}
        variant="secondary"
        size="lg"
        fullWidth
        color="blue"
        data-testid="register-to-event-show-calendar"
        contentClassName={styles.addToCalender}
        className={styles.addToCalenderButton}
      >
        {t("eventLanding:add.calendar")}
      </Button>
      {!event.isPrivate && (
        <ShareEvent
          eventData={event}
          showText
          border={false}
          copyLinkId="add-to-calendar-modal_secondary-cta-copy-link"
        />
      )}
    </div>
  );
};

export default RegistrationSuccess;
